import type { PersistedClient, Persister } from '@tanstack/react-query-persist-client'
import { del, get, set } from 'idb-keyval'

/**
 * IndexedDB-backed persister for TanStack Query, following the official docs
 * pattern. IndexedDB is faster than Web Storage, exceeds the 5MB limit, and
 * stores structured data without manual serialization.
 *
 * @see https://tanstack.com/query/v5/docs/framework/react/plugins/persistQueryClient
 */
export function createIDBPersister(idbValidKey: IDBValidKey = 'tintin-react-query'): Persister {
  return {
    persistClient: async (client: PersistedClient) => {
      await set(idbValidKey, client)
    },
    restoreClient: async () => {
      return await get<PersistedClient>(idbValidKey)
    },
    removeClient: async () => {
      await del(idbValidKey)
    },
  }
}

export const idbPersister = createIDBPersister()

export default idbPersister
